module.exports = __webpack_public_path__ + "img/monitor.d5553ea7.svg";